import React from 'react'

const Testimonials = () => {
  return (
     <div className='backdiv'>
        
         <h2 className='main_heading'>CLIENT <br/>TESTIMONIALS</h2>  
            <div className='testii-card'>
<p className='main_content'>" We’ve worked with several marketing teams over the years, and this has been by far the best advertising management team we’ve partnered with. Their strategy, communication, and attention to detail consistently delivered quality leads and improved our visibility. Their commitment to performance and transparency has made a real impact on our business."</p>
<p className='testii_name'>— Shadow Wood Flooring</p>
            </div>


    </div>
  )
}

export default Testimonials